import * as React from 'react';
import { styles } from './styles';
import { ChevronDown } from '@routes/event/create/components/ChevronDown';

interface Props {
  label: string;
  collapsible?: boolean;
  open?: boolean;
  isMobile?: boolean;
  subtitle?: string | JSX.Element;
}

export const DesignBucketLabel: React.SFC<Props> = ({ label, collapsible, open, isMobile, subtitle }) => {
  return (
    <div className={styles.labelContainer}>
      <button className={styles.labelInner}>
        <span className={styles.label}>{label}</span>
        {collapsible && <ChevronDown className={styles.chevron(!!open)} />}
      </button>
      {isMobile && <div className={styles.valueContainer}>{subtitle || 'All'}</div>}
    </div>
  );
};
